import { styled } from '@material-ui/core';
import { ReactComponent as RadioCheckedIcon } from 'assets/icons/radio-checked.svg';
import { ReactComponent as RadioUnCheckedIcon } from 'assets/icons/radio-unchecked.svg';

export const Wrapper = styled('div')({
  display: 'flex',
  alignItems: 'flex-start',
});

export const ButtonContainer = styled('div')(({ colour }) => ({
  width: '18px',
  height: '18px',
  position: 'relative',
  color: `${colour}`,
}));

export const InvisibleInput = styled('input')({
  position: 'absolute',
  width: '100%',
  height: '100%',
  left: 0,
  top: 0,
  opacity: 0,
  cursor: 'pointer',
});

export const CheckedIcon = styled(RadioCheckedIcon)({
  width: '100%',
  height: '100%',
});

export const UnCheckedIcon = styled(RadioUnCheckedIcon)({
  width: '100%',
  height: '100%',
});

export const ButtonLabel = styled('div')(({ theme }) => ({
  //display: 'inline-block',
  marginLeft: '8px',
  color: theme.palette.common.black,
  fontSize: '14px',
}));
